import {
  ECustomFieldType,
  EDisplaySetting,
  EEncodingType,
  EParseType,
  EUserType,
  ValueDateOptions,
} from '../enums/index'
import { IAuditData } from './model/audit'
import { IAddress } from './model/fieldDefinition'
export * from './mobileTypes'
export * from './model/audit'
export * from './model/barcode'
export * from './model/fieldData'
export * from './model/fieldDefinition'
export * from './model/project'
export * from './portalTypes'
export * from './tradeWaltzTypes/index'

export interface IUiConfig {
  trackpointFlowchartVisibility?: EDisplaySetting
  tracingVisibility?: EDisplaySetting
  parentBarcodeVisibility?: EDisplaySetting
  childrenBarcodeVisibility?: EDisplaySetting
  listViewTitleLabelField?: string
  qrCodeVisibility?: EDisplaySetting
  previewAddTrackingVisiblity?: EDisplaySetting
}

export interface ILabelDisplay {
  label: string
  value: string | IListStringItem[]
  fieldType?: ECustomFieldType
}

export interface IListStringItem {
  id?: number
  conversionUnit?: string
  itemCode?: string
  itemName?: string
  productId?: number
  code: string
  limitAmount?: number
  amount?: number
  currentAmount?: number
  unit?: string
  createdDateTime?: string
  initAmount?: number
  warnings?: number[]
  trollyIndex?: number
  trollyNumber?: number
  orderNumber?: string
  machineCode?: string
  refAmount?: string
  refOrderNumber?: string
  refTrollyIndex?: number
  scannedDateTime?: string
}

export interface IDimension {
  width?: number | string
  height?: number | string
  depth?: number | string
  weight?: number | string
}

export interface TreeNode {
  id: number
  label: string
  keyPath: string
  children?: TreeNode[]
}

export interface IProduct {
  clientId: string
  name: string
  code: string
  version: number
  supplier: Supplier
  dimension: IDimension
  volume: number
  material: string
  id: string
  audit: IAuditData
  isActive: boolean
}

export interface Supplier {
  country: string
  postalCode: string
  prefecture: string
  address1: string
  address2: string
  phoneNumber: string
  companyName: string
}

export declare type UploadFile = {
  name: string
  percentage?: number
  status: UploadStatus
  size: number
  response?: unknown
  uid: number
  url?: string
  raw: ElFile
}

export interface ElFile extends File {
  uid: number
}

export declare type UploadStatus = 'ready' | 'uploading' | 'success' | 'fail'

/// ==== Search
export interface IBarcodeSearchFormItem {
  bcTypeKey?: string
  key: string
  subKey?: string
  componentType?: string
  value?: string
  valueList?: string[]
  minValue?: string | number
  maxValue?: string | number
  valueType?: string
  isExactValue?: boolean
  valueDate?: ValueDateOptions
  workCenterId?: string
  warehouseId?: string
}

export interface IBarcodeOptionFormItem {
  bcTypeKey?: string
  key: string
  subKey?: string
  componentType?: string
  value?: string | number
  valueList?: string[]
  minValue?: string | number
  maxValue?: string | number
  valueType?: string
  isExactValue?: boolean
}

export interface ISearchConditionBlock {
  searchConditions: IBarcodeSearchFormItem[]
  logicalOperator?: string
}

export interface IBarcodeSearchForm {
  projectCode: string
  version: number
  utcOffset?: number
  searchConditionBlocks: ISearchConditionBlock[]
  logicalOperator?: string
  count?: number
  skip?: number
  isToday?: boolean
  sortKey: string | null
  sortOrder: number
}

export interface ISavedSearchCondition {
  id: string
  name: string
  searchContext: string
  conditionJson: IBarcodeSearchForm
  createdAt: string
  updatedAt: string
}

export declare type IMessageType = 'success' | 'warning' | 'info' | 'error' | ''

// Organization
export interface IOrganization {
  address: IAddress
  code: string
  enableTimetable: boolean
  setDisplayedBarcodeByClient?: boolean
  isTradeWaltzPermission?: boolean
  isArchiveBarcodePermission?: boolean
  enableTrackPointRouteNotificationSetting: boolean
  id: string
  enterpriseId: string
  isActive: boolean
  name: string
  enterpriseIds: Array<string>
  audit: IAuditData
  enableSearchTrackingData?: boolean
  whiteListIp: Array<IIpRange>
  systemPermission: {
    isClient: boolean
    isInventory: boolean
  }
  projectPermission: {
    isAutoRecycleEndTrackingPoint: boolean
    barcodeTypePermission: {
      isReportOutput: boolean
      isPair: boolean
      isLink: boolean
      isCustomValidation: boolean
      isExternalId: boolean
      isNotification: boolean
      isGHGEmissionCustomField: boolean
      isReferenceCustomField: boolean
      isCustomContent: boolean
    }
  }
}

export interface IIpRange {
  endIp?: string
  startIp: string
  note: string
}

// User
export interface IUser {
  roleType: string
  encodingType: EEncodingType
  userType: EUserType
  entitledPortalUIViews: Array<string>
  organizationId: string
  email: string
  firstName: string
  lastName: string
  fullName: string
  id: string
  audit: IAuditData
  isActive: boolean
  companyType?: Array<string>
  savedSearchConditions?: ISavedSearchCondition[]
}

export type TParserSettingItem = {
  targetFieldPath: string
} & (
  | {
      parserType: EParseType.REGEX
      regexRule: string
      index?: number
    }
  | {
      parserType: EParseType.LENGTH
      startPosition: number
      endPosition: number
    }
  | {
      parserType: EParseType.DELIMITER
      delimiter: string
      index: number
    }
)
